import React from 'react';
import {
	ReadOnlyTextField,
	type ReadOnlyTextFieldProps,
} from '@netx/core-components/TextField';
import {type SelectFieldProps} from '../../SelectField';

export type ReadOnlySelectFieldProps<T = any> = ReadOnlyTextFieldProps &
	Omit<SelectFieldProps<T, false, true, false>, 'options'>;

export const ReadOnlySelectField = ({
	value,
	...props
}: ReadOnlySelectFieldProps) => {
	return (
		<ReadOnlyTextField
			{...props}
			value={props?.getOptionLabel ? props?.getOptionLabel(value) : value}
		/>
	);
};

export default ReadOnlySelectField;
